/* @ngInject */
function assetService (
  $rootScope,
  $cookies,
  ConnectorWebService,
  CONSTANTS,
  Utils,
  UploadService,
  ToastService,
  DataService
) {
  $rootScope.uploadingFiles = []
  const assetExtensions = [
    // AUDIO
    { extension: 'mp3', img: 'audio.jpg', repositoryThumb: 'audio.png' },
    { extension: 'wav', img: 'audio.jpg', repositoryThumb: 'audio.png' },
    { extension: 'wma', img: 'audio.jpg', repositoryThumb: 'audio.png' },
    { extension: 'aac', img: 'audio.jpg', repositoryThumb: 'audio.png' },
    { extension: 'ac3', img: 'audio.jpg', repositoryThumb: 'audio.png' },

    // DOCUMENTS
    { extension: 'pdf', img: 'pdf.jpg', repositoryThumb: 'pdf.png' },
    { extension: 'doc', img: 'doc.jpg', repositoryThumb: 'doc.png' },
    { extension: 'docx', img: 'doc.jpg', repositoryThumb: 'docx.png' },
    { extension: 'txt', img: 'file.jpg', repositoryThumb: 'txt.png' },
    { extension: 'csv', img: 'excel.jpg', repositoryThumb: 'sheet.png' },
    { extension: 'xls', img: 'excel.jpg', repositoryThumb: 'sheet.png' },
    { extension: 'xlsx', img: 'excel.jpg', repositoryThumb: 'sheet.png' },
    { extension: 'ods', img: 'excel.jpg', repositoryThumb: 'sheet.png' },
    { extension: 'ppt', img: 'ppt.jpg', repositoryThumb: 'ppt.png' },
    { extension: 'pptx', img: 'ppt.jpg', repositoryThumb: 'pptx.png' },
    { extension: 'zip', img: 'zip.jpg', repositoryThumb: 'zip.png' },
    { extension: 'ext', img: 'file.jpg', repositoryThumb: 'file.png' },
    { extension: 'deskfy', img: 'file.jpg', repositoryThumb: 'doc_editor.png' },

    // DESIGN
    { extension: 'ai', img: 'illustrator.jpg', repositoryThumb: 'ai.png' },
    { extension: 'psd', img: 'photoshop.jpg', repositoryThumb: 'psd.png' },
    { extension: 'svg', img: 'file.jpg', repositoryThumb: 'svg.png' },
    { extension: 'eps', img: 'file.jpg', repositoryThumb: 'eps.png' },
    { extension: 'crd', img: 'file.jpg', repositoryThumb: 'crd.png' }
  ]
  const supportedContentTypes = [
    'image/png',
    'image/jpeg',
    'image/tiff',
    'image/webp',
    'image/bmp',
    'image/gif',
    'image/svg+xml',
    'img/png',
    'image/avif',
    'image/jpg',
    'image/heic',
    'video/mp4',
    'video/mpeg',
    'video/quicktime',
    'video/x-m4v',
    'video/avi',
    'video/ogg',
    'video/3gpp',
    'video/webm',
    'video/x-flv',
    'video/x-matroska',
    'video/x-msvideo',
    'video/x-ms-vob',
    'video/x-ms-wmv',
    'application/pdf',
    'image/vnd.adobe.photoshop',
    'image/x-psd',
    'image/psd',
    'application/x-photoshop',
    'application/illustrator',
    'application/postscript',
    'image/ai'
  ]

  const service = {
    downloadAsset,
    downloadAssetWithProgress,
    uploadAttachments,
    updateAsset,
    mapGetResponse,
    archiveBrandSectionAsset,
    bulkArchiveBrandSectionAsset,
    getAssetUrlThumbnail,
    getFileUrlThumbnail,
    getAssetThumbnailByType,
    generateDownloadToken,
    getDeskfyDefaultPreviewFormats,
    getSupportedContentTypes,
    uploadTemplate,
    getAssetsWithArts,
    getAssetDetailsById,
    updateUploadedAsset,
    getDownloadAssetUrl,
    draggableOptions,
    helperFunction,
    getAssetSrcAttributes,
    bindAssetToCampaign,
    unbindAssetFromCampaign
  }
  return service

  function getDownloadAssetUrl (id) {
    return Utils.fnReplaceStringParams(CONSTANTS.URL_NEW_ASSETS_ID_DOWNLOAD, [id])
  }

  function downloadAsset (id, downloadModule, version) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_NEW_ASSETS_ID_DOWNLOAD, [id])

    if (downloadModule) {
      url = Utils.fnAddQueryToUrl(url, { downloadModule })
    }

    if (version) {
      url = Utils.fnAddQueryToUrl(url, { assetVersion: version })
    }

    return Utils.downloadFile(url)
  }

  function downloadAssetWithProgress (id, onProgress, callback) {
    const assetUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_NEW_ASSETS_ID_DOWNLOAD, [id])
    const url = Utils.fnAddQueryToUrl(assetUrl, { jwt: $cookies.get('jwt') })

    return ConnectorWebService.createCustomXHR(
      url,
      'GET',
      null,
      { responseType: 'blob' },
      {
        load: () => {
          return function () {
            callback(this.response)
          }
        },
        progress: onProgress
      },
      { externalUrl: true }
    )
  }

  function uploadAttachments (aAssets, flags, mExtraData, onSuccess) {
    if (!aAssets || !aAssets.length) {
      return
    }

    var mCallbacks = {
      fnSuccess: onSuccess || function () {},
      fnError: ToastService.defaultErrorToast,
      fnProgress: function (file) {
        return function (event) {
          if (!event.lengthComputable) {
            return
          }

          var percentage = (event.loaded / event.total) * 100
          file.percentage = parseInt(percentage, 10)
        }
      }
    }

    const options = {
      simultaneousLimit: 5,
      allFiles: []
    }

    if (!flags) {
      options.allFiles = $rootScope.uploadingFiles
    }

    return UploadService.uploadWithCustomProgress(
      CONSTANTS.URL_CUSTOMER_ASSETS,
      aAssets,
      mCallbacks,
      options,
      mExtraData
    )
  }

  function updateAsset (iAssetId, oPayload) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_ID, [iAssetId])

    return ConnectorWebService.put(sUrl, oPayload)
  }

  function mapGetResponse (oRes) {
    var results = oRes.d.results.map(asset => {
      return {
        ...asset,
        id: asset.id,
        categoryId: asset.categoryId,
        sectionId: asset.sectionId,
        contentType: asset.contentType,
        type: asset.type,
        extension: asset.extension,
        name: asset.name,
        size: asset.size,
        isPrivate: asset.isPrivate,
        createdBy: asset.createdBy,
        allowUserDownload: asset.allowUserDownload,
        src: getAssetSrcAttributes(asset)
      }
    })

    oRes.d.results = results
    return oRes
  }

  function getAssetSrcAttributes (asset) {
    let thumbnailSrc = ''

    if (supportedContentTypes.indexOf(asset.contentType) > -1) {
      thumbnailSrc = Utils.fnReplaceStringParams(CONSTANTS.URL_NEW_ASSETS_ID_THUMBNAIL, [asset.id])
    }

    return {
      original: Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_DOWNLOAD_ID, [asset.id]),
      default: getAssetThumbnailByType(asset),
      thumbnail: thumbnailSrc,
      optimized:
        Utils.optimizeAsset(asset) &&
        Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_OPTIMIZED_ID, [asset.id])
    }
  }

  function getAssetUrlThumbnail (assetId) {
    return Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_THUMBNAIL_ID, [assetId])
  }

  function getFileUrlThumbnail (fileId) {
    return Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPORARY_FILES_UUID_THUMBNAIL, [fileId])
  }

  function getAssetThumbnailByType (asset) {
    const baseRepositoryPath = '/assets/img/repository_asset_thumbs/'
    const defaultThumb = baseRepositoryPath + 'file.png'

    if (!asset) {
      return defaultThumb
    }

    const repositoryAssetExtension = assetExtensions.find(
      assetExtension => assetExtension.extension === asset.extension
    )

    if (repositoryAssetExtension) {
      return `${baseRepositoryPath}${repositoryAssetExtension.repositoryThumb}`
    } else {
      return defaultThumb
    }
  }

  function generateDownloadToken (assetId) {
    var url = Utils.fnReplaceStringParams(CONSTANTS.URL_ASSETS_ID_DOWNLOAD_TOKEN, [assetId])
    return ConnectorWebService.get(url)
  }

  function getDeskfyDefaultPreviewFormats () {
    return {
      supportedExtensions: ['jpeg', 'jpg', 'png', 'pdf', 'mp3', 'mp4', 'svg', 'ai', 'psd']
    }
  }

  function getSupportedContentTypes () {
    return supportedContentTypes
  }

  function uploadTemplate (dataPayload) {
    return ConnectorWebService.post(CONSTANTS.URL_ASSETS, dataPayload)
  }

  function getAssetsWithArts (assetsId) {
    const url = Utils.addQueryStringFromArray(CONSTANTS.URL_ASSETS_HAS_ARTS, 'ids', assetsId)
    return ConnectorWebService.get(url)
  }

  function archiveBrandSectionAsset (assetId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ASSETS_ID_ARCHIVE, [assetId])
    return ConnectorWebService.put(url)
  }

  function bulkArchiveBrandSectionAsset (assetIds) {
    return ConnectorWebService.put(CONSTANTS.URL_ASSETS_BATCH_ARCHIVE, {
      ids: assetIds
    })
  }

  function getAssetDetailsById (assetId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ASSETS_ID_DETAILS, [assetId])
    return ConnectorWebService.get(url)
  }

  function updateUploadedAsset (id, payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ASSETS_ID, [id])
    return ConnectorWebService.put(url, payload)
  }

  function draggableOptions (thumbnailImgSrc, left, top, highResolutionImgSrc, imageId, externalUrl, onDropHandler, isVideo) {
    return {
      start: function (event, ui) {
        DataService.onDropFunction = onDropHandler(thumbnailImgSrc, highResolutionImgSrc, imageId, externalUrl, isVideo)
      },
      helper: function () {
        return helperFunction(thumbnailImgSrc)
      },
      drag: function (event, ui) {
        $.each($('svg > image.clipped-image'), function (index, frame) {
          const isPhotoframe = frame.matches(':hover')

          if (isPhotoframe && frame.instance.mouseoverImage) {
            frame.instance.mouseoverImage.load(thumbnailImgSrc).opacity('1')
            frame.instance.opacity('0.1')
          }
        })
      },
      cursor: 'move',
      appendTo: 'body',
      scroll: false,
      zIndex: 99999,
      containment: 'document',
      cursorAt: { left: left, top: top }
    }
  }

  function helperFunction (thumbnailImgSrc) {
    var img = document.createElement('img')
    img.src = thumbnailImgSrc
    img.className = 'img-draggable-helper fadeIn'

    if (!isNaN(img.height) && !isNaN(img.width)) {
      let baseMeasure = 175
      const imgHeight = img.height
      const imgWidth = img.width
      let aspectRatio = null
      let newHeight = imgHeight
      let newWidth = imgWidth

      const minDimension = Math.min(imgHeight, imgWidth)

      if (baseMeasure > minDimension) {
        baseMeasure = minDimension
      }

      if (imgHeight > imgWidth) {
        aspectRatio = imgHeight / imgWidth
        newHeight = aspectRatio * baseMeasure
        newWidth = baseMeasure
      } else {
        aspectRatio = imgWidth / imgHeight
        newWidth = aspectRatio * baseMeasure
        newHeight = baseMeasure
      }

      img.style.height = `${newHeight}px`
      img.style.width = `${newWidth}px`
    }

    return img
  }

  function bindAssetToCampaign (params = {}) {
    const { assetId, selectedCampaign } = params

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ASSETS_ID_BIND_CAMPAIGN, [assetId])
    return ConnectorWebService.put(url, { campaignId: selectedCampaign })
  }

  function unbindAssetFromCampaign (assetId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ASSETS_ID_UNBIND_CAMPAIGN, [assetId])
    return ConnectorWebService.put(url)
  }
}

export { assetService }
